import { render, staticRenderFns } from "./bar_button_group.vue?vue&type=template&id=428327d6&scoped=true"
import script from "./bar_button_group.vue?vue&type=script&lang=ts"
export * from "./bar_button_group.vue?vue&type=script&lang=ts"
import style0 from "./bar_button_group.vue?vue&type=style&index=0&id=428327d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428327d6",
  null
  
)

export default component.exports